import { supabase } from "@/integrations/supabase/client";

export type LinkCategory = "phone" | "email" | "heyflow" | "provenexpert" | "wizard_cta";

const getOrCreateSessionId = (): string => {
  let id = sessionStorage.getItem("click_session_id");
  if (!id) {
    id = `cs_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
    sessionStorage.setItem("click_session_id", id);
  }
  return id;
};

export const trackClick = (
  label: string,
  category: LinkCategory,
  url?: string
): void => {
  // Fire & forget — never block the user
  try {
    supabase
      .from("link_clicks")
      .insert({
        link_label: label,
        link_category: category,
        link_url: url ?? null,
        page_path: window.location.pathname,
        session_id: getOrCreateSessionId(),
        user_agent: navigator.userAgent,
      })
      .then(({ error }) => {
        if (error) console.warn("Click tracking failed:", error.message);
      });
  } catch (err) {
    console.warn("Click tracking error:", err);
  }
};
